(function () {
    angular.module('invesfleet')
        .directive('searcher', searcher);

    searcher.$inject = ['common'];

    function searcher(common) {

        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/views/directives/searcher.html',
            scope: {
                ngModel: '=?',
                searcherInput: '@',
                searcherButton: '@',
                searcherClearButton: '@',
                onSearch: '&?',
                onClear: '&?',
                placeholder: '@?',
                useEnterKey: '=?'
            }
        };
        return directive;

        function link(scope, element, attrs) {

            var container;
            var input;
            var button;
            var clear;
            var searched = false;
            var lastSearch = '';

            if (common.isNullOrUndefined(scope.useEnterKey))
                scope.useEnterKey = false;
            if (common.isNullOrUndefined(scope.placeholder)) {
                scope.placeholder = 'Buscar...'; // N� Orden, Exp. o Matr�cula
            }

            function hasValue() {
                return !common.isNullOrUndefined(input.value) && input.value.length > 0;
            }

            function inputFocus() {
                if (input === document.activeElement)
                    return;
                setTimeout(() => {
                    input.focus();
                }, 100);
            }

            function behave(containerState, buttonState, clearState, inputValue) {

                if (inputValue !== null) {
                    input.value = inputValue;
                    scope.ngModel = input.value;
                }

                switch (containerState) {
                    case 'show':
                        container.classList.add('display');
                        break;
                    case 'hide':
                        container.classList.remove('display');
                        break;
                    case 'toggle':
                    default:
                        container.classList.toggle('display');
                        break;
                }

                switch (buttonState) {
                    case 'show':
                        button.classList.remove('none');
                        break;
                    case 'hide':
                        button.classList.add('none');
                        break;
                    case 'toggle':
                    default:
                        button.classList.toggle('none');
                        break;
                }

                switch (clearState) {
                    case 'show':
                        clear.classList.remove('none');
                        break;
                    case 'hide':
                        clear.classList.add('none');
                        break;
                    case 'toggle':
                    default:
                        clear.classList.toggle('none');
                        break;
                }
            }

            function search() {
                lastSearch = input.value;
                if (scope.onSearch) {
                    setTimeout(() => {
                        scope.onSearch();                        
                    }, 100);
                }
            }

            function doClear() {
                lastSearch = '';
                if (scope.onClear) {
                    setTimeout(() => {
                        scope.onClear();
                    }, 100);
                }
            }

            container = element[0];
            input = container.querySelector(scope.searcherInput);
            button = container.querySelector(scope.searcherButton);
            clear = container.querySelector(scope.searcherClearButton);

            button.addEventListener('click', (event) => {
                if (!searched) {
                    if (!hasValue()) {
                        behave('toggle', 'show', 'hide', '');
                        inputFocus();
                    } else {
                        search();
                        behave('show', 'show', 'show', null);
                        searched = true;
                    }
                } else {
                    search();
                    behave('show', 'show', 'show', null);
                }
            });

            clear.addEventListener('click', (event) => {
                behave('hide', 'show', 'hide', '');
                doClear();
                searched = false;
            });

            input.addEventListener('keyup', (event) => {
                event.preventDefault();
                event.stopPropagation();

                if (!scope.useEnterKey) {
                    search();
                    behave('show', 'show', 'show', null);
                    searched = true;
                } else if (scope.useEnterKey && event.keyCode === 13) {
                    if (hasValue()) {
                        search();
                        behave('show', 'show', 'show', null);
                        searched = true;
                    } else {
                        input.value = lastSearch;
                    }
                }
            });

            input.addEventListener('change', (event) => {
                if (searched)
                    behave('show', 'show', 'show', null);
                else
                    behave('show', 'show', 'hide', null);
            });

            input.addEventListener('focusin', (event) => {
                input.select();
            });

            input.addEventListener('focusout', (event) => {
                if (!searched && !hasValue()) {
                    behave('hide', 'show', 'hide', '');
                    searched = false;
                } else if (searched && (!hasValue() || lastSearch != input.value)) {
                    input.value = lastSearch;
                }
            });
        };
    }
})();